<template>
    <div class="signInfo">
        <p class="info_title">报名用户（{{formList.length}}/{{collectinfo.allticketcount}}）</p >
        <el-form :model="formList" :rules="rules" ref="formList" label-width="auto" class="demo-ruleForm">
            <div class="sign_box" v-for="(item,index) in formList" :key="index">
                <div class="sign_title" v-if="collectinfo.iscollectenrollinfo==1">
                    <div class="l_title">第{{index+1}}位报名人 <span @click="delPerson(index)" v-if="index>0">删除</span></div>
                    <div class="r_title" @click="handleOpen(item)"><img :src="item.isopen?detUp:detUnder" alt="">{{item.isopen?'收起':'展开'}}</div>
                </div>
                <div class="sign_title" v-else>报名人信息</div>
                <div class="sign_content" v-if="item.isopen">
                    <el-form-item label="姓名" :prop="index + '.joinername'" :rules="{required: true, message: '请输入姓名', trigger: 'blur'}">
                        <el-input v-model="item.joinername"></el-input>
                    </el-form-item>
                    <el-form-item label="手机" :prop="index + '.joinermobile'" :rules="{required: true, message: '请输入手机号', trigger: 'blur'}">
                        <el-input v-model="item.joinermobile" oninput = "value=value.replace(/[^\d]/g,'')" maxlength="11"></el-input>
                    </el-form-item>
                    <!--循环formdata -->
                    <el-form-item v-for="(list,$index) in item.formdata"  :key="`${index}-${$index}`" :label="list.colname" :prop="index + '.formdata.' + $index + '.colvalue'" :rules="{required: list.isnotnull==1, message: '请输入'+list.colname, trigger: 'blur'}">
                        <el-input v-model="list.colvalue" v-if="list.coltype==1" :placeholder="list.placeholder"></el-input>
                        <el-input type="textarea" v-model="list.colvalue" v-if="list.coltype==5" :placeholder="list.placeholder"></el-input>
                        <el-date-picker v-model="list.colvalue" type="date" :placeholder="list.placeholder" v-if="list.coltype==3" value-format="yyyy-MM-dd"></el-date-picker>
                        <el-radio-group v-model="list.colvalue" v-if="list.coltype==6">
                            <el-radio v-for="item in list.optionsinfo.split(',')" :key="item" :label="item"></el-radio>
                        </el-radio-group>
                        <el-checkbox-group :value="list.colvalue?list.colvalue.split(','):[]" @input="val => list.colvalue = val.join(',')" v-if="list.coltype==7">
                            <el-checkbox v-for="item in list.optionsinfo.split(',')" :key="item" :label="item"></el-checkbox>
                        </el-checkbox-group>
                        <el-select v-model="list.colvalue" :placeholder="list.placeholder" v-if="list.coltype==8">
                            <el-option  v-for="item in list.optionsinfo.split(',')" :key="item" :label="item" :value="item"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </div>
        </el-form>
        <!--新增报名人-->
        <el-button type="danger" plain @click="addPerson" v-if="collectinfo.iscollectenrollinfo==1&&formList.length!=collectinfo.allticketcount">新增报名人</el-button>
    </div>
</template>

<script>
    export default {
        name: "signInfo",
        props:['collectinfo','eventticketinfo','formList'],
        data(){
            return{
                isopen:true,
                detUnder:require('@/common/images/hd/detUnder.png'),
                detUp:require('@/common/images/hd/detUp.png'),
                rules:{

                },
            }
        },
        computed: {
            //初始化表单，只重置了colvalue
            defaultColList () {
                if (this.formList.length) {
                    return this.formList[0].formdata.map(item => ({
                        ...item,
                        colvalue: ''
                    }))
                }
                return []
            }
        },
        mounted(){

        },
        methods:{
            //是否展开活动表单
            handleOpen(item){
                // this.formList.forEach((item)=>{
                //     this.$set(item,'isopen',false)
                // });
                this.$set(item,'isopen',!item.isopen)
            },
            //新增报名人
            addPerson(){
                const error = this.formList.some(item => item.joinername =='' || item.joinermobile == '');
                const error2 = this.formList.some(item => item.formdata.some(item2=>item2.isnotnull==1&&item2.colvalue==''));
                if(error||error2){
                    this.$message({
                        message: '请填写必填项',
                        type: 'warning'
                    });
                }else{
                    this.formList.forEach((item)=>{
                        this.$set(item,'isopen',false)
                    });
                    // 新增报名人信息
                    this.formList.push({
                        joinername: '',
                        joinermobile: '',
                        isopen: true,
                        formdata: this.defaultColList
                    })
                }
            },
            delPerson(index){
                console.log(index);
                if(index!==0){
                    this.formList.splice(index,1)
                }
            },
        },
    }
</script>

<style lang="scss">
    .signInfo{
        width: 680px;
        margin-right: 20px;
        margin-left: 2px;
        .info_title{
            border-left: 2px solid #1464C8;
            padding-left: 5px;
            margin-bottom: 20px;
        }
        .sign_box{
            background: rgba(255,255,255,1);
            box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.1);
            border-radius: 6px;
            padding: 20px;
            margin-bottom: 15px;
            .sign_title{
                display: flex;
                justify-content: space-between;
                font-size: 14px;
                color: #999;
                .l_title{
                    span{
                        color: #F56C6C;
                        margin-left: 20px;
                        cursor: pointer;
                    }
                }
                .r_title{
                    font-size: 12px;
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    img{
                        margin-right: 5px;
                    }
                }
            }
            .sign_content{
                margin-top: 20px;
                .el-select,.el-date-editor.el-input{
                    width: 100%;
                }
            }
        }
        .el-button--danger.is-plain{
            display: flex;
            margin: auto;
            color: #1464C8;
            border-color: rgba(20,100,200,1);
            background: none;
        }
        .el-button--danger.is-plain:focus, .el-button--danger.is-plain:hover {
            background: rgba(20,100,200,1);
            border-color: rgba(20,100,200,1);
            color: #FFF;
            outline: 0;
        }
    }
</style>